import React, { Component } from "react";
import { connect } from "react-redux";
import { changePassword_action, verifyOtp_action } from "../../actions/user_login_auth_actions/user_login_auth_action";
import { withRouter } from "../../utils/withRouter";
import {
  confirmPasswordValidator,
  oldPasswordValidator,
  passwordValidator,
} from "../../utils/Validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../common_components/Header";
import { toastError, toastSuccess } from "../../utils/constants";

const mapStateToProps = (state) => ({
  ...state,
});

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPassword: "",
      newPassword: "",
      confirm_pass: "",
      isLoading: false,
      is_showNewpass: false,
      is_showOldpass: false,
      is_showConfirmpass: false,
      otp_id: "", isReset: false
      // is_forgotPassword: false,
    };
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleObscure = this.handleObscure.bind(this);
  }

  componentDidMount() {
    const { isReset, otp_id } = this.state
    if (this.props.location != null) {
      var url;
      if (
        this.props.location.pathname != null &&
        this.props.location.pathname.includes('/changePassword/')
      ) {
        url =
          this.props.location.pathname != null &&
          this.props.location.pathname.split("/changePassword/");

        this.setState({
          otp_id: url != "" ? (url[1] != "" ? url[1].toString() : "") : "",
          isReset: 1
        }, () => {
          this.verifyOtp()
        });
      }
    } else {
      if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
        setTimeout(() => {
          this.props.navigate("/login");
        }, 500);
      }
    }
    this.setState({
      user_id:
        sessionStorage.getItem("user_id") == "" ||
          sessionStorage.getItem("user_id") == null
          ? ""
          : sessionStorage.getItem("user_id"),
      user_name:
        sessionStorage.getItem("user_name") == "" ||
          sessionStorage.getItem("user_name") == null
          ? ""
          : sessionStorage.getItem("user_name"),
    });
    // clearsessionStorage("");
    this.setState({
      is_forgotPassword:
        this.props.location.state != null &&
          this.props.location.state.is_forgotPassword != null
          ? this.props.location.state.is_forgotPassword
          : false,
    });
  }
  verifyOtp() {
    const { otp_id } = this.state
    this.setState({ isLoading: true })
    this.props.verifyOtp_action(otp_id).then((data) => {
      if (data.error !== 1) {
        var resultMsg = data.data[0].verificationResult
        if (resultMsg == 'Link Expired') {
          toastError(resultMsg)
          setTimeout(() => {
            this.props.navigate('/')
          }, 2000);
        } else {
          toastSuccess(resultMsg)
        }
      }
    })
  }
  handleObscure(pass) {
    const { is_showOldpass, is_showConfirmpass, is_showNewpass } = this.state;
    if (pass == "newPassword") {
      this.setState({ is_showNewpass: !is_showNewpass });
    } else if (pass == "currentPassword") {
      this.setState({ is_showOldpass: !is_showOldpass });
    } else if (pass == "confirm_pass") {
      this.setState({ is_showConfirmpass: !is_showConfirmpass });
    }
  }

  handleChangePassword = () => {
    const { currentPassword, newPassword, confirm_pass, isReset, otp_id } = this.state;

    // Validation
    const errMsg = isReset ? "" : oldPasswordValidator(currentPassword, newPassword);
    const errMsg2 = passwordValidator(newPassword);
    const errMsg3 = confirmPasswordValidator(confirm_pass, newPassword);

    if (errMsg || errMsg2 || errMsg3) {
      toastError(errMsg || errMsg2 || errMsg3);
      return;
    }

    // Handle password change/reset
    if (
      newPassword &&
      confirm_pass &&
      (isReset ? !currentPassword : currentPassword && newPassword === confirm_pass)
    ) {
      this.setState({ isLoading: true });

      this.props
        .changePassword_action(isReset, otp_id, currentPassword, newPassword)
        .then((data) => {
          if (data.error !== 1) {
            this.setState({ isLoading: false });
            toastSuccess("Password changed successfully. Please login again.");
            setTimeout(() => {
              sessionStorage.clear();
              this.props.navigate("/login");
            }, 1000);
          } else {
            if (data.msg == "Link Expired") {
              toastError(data.msg);
              this.setState({ isLoading: false });
              setTimeout(() => {
                this.props.navigate('/login')
              }, 3000);
            } else {
              toastError(data.msg);
              this.setState({ isLoading: false });
            }
          }
        })
        .catch((e) => {
          this.setState({ isLoading: false });
          console.error(e);
        });
    } else {
      this.setState({ isLoading: false });
      toastError("Please check your password");
    }
  };

  render() {
    const {
      currentPassword,
      newPassword,
      confirm_pass,
      is_showOldpass,
      is_showConfirmpass,
      is_showNewpass,
      is_forgotPassword, isReset, otp_id
    } = this.state;

    return (
      <>
        <div className="login-container">
          <div className="login-box">
            <div className="form-section">
               <marquee
                  style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                  behavior="scroll"
                  direction="left"
                  scrollamount="5"
                  onMouseOver={(e) => e.target.stop()}
                  onMouseOut={(e) => e.target.start()}
                >
                 <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                </marquee>
              <img src="img/login_logo.png" alt="Logo" className="logo" />
              <h2>{isReset ? "Set" : "Change"} Password</h2>
              <p>{isReset ? "Set New Password" : "Your new password must be different from previously used passwords."}</p>
              {isReset ? <></> : <>
                <div className="password-container">
                  <input
                    type={is_showOldpass ? "text" : "password"}
                    value={currentPassword}
                    onChange={(e) => this.setState({ currentPassword: e.target.value })}
                    maxLength={16}
                    placeholder="Current Password"
                    className="input-field"
                  />
                  <i
                    className={`fa ${is_showOldpass ? "fa-eye-slash" : "fa-eye"} show-password`}
                    onClick={() =>
                      this.setState((prevState) => ({ is_showOldpass: !prevState.is_showOldpass }))
                    }
                  ></i>
                </div>
              </>}
              <div className="password-container">
                <input
                  type={is_showNewpass ? "text" : "password"}
                  value={newPassword}
                  onChange={(e) => this.setState({ newPassword: e.target.value })}
                  maxLength={16}
                  placeholder="Password"
                  className="input-field"
                />
                <i
                  className={`fa ${is_showNewpass ? "fa-eye-slash" : "fa-eye"} show-password`}
                  onClick={() =>
                    this.setState((prevState) => ({ is_showNewpass: !prevState.is_showNewpass }))
                  }
                ></i>
              </div>
              <div className="password-container">
                <input
                  type={is_showConfirmpass ? "text" : "password"}
                  value={confirm_pass}
                  onChange={(e) => this.setState({ confirm_pass: e.target.value })}
                  maxLength={16}
                  placeholder="Confirm Password"
                  className="input-field"
                />
                <i
                  className={`fa ${is_showConfirmpass ? "fa-eye-slash" : "fa-eye"} show-password`}
                  onClick={() =>
                    this.setState((prevState) => ({ is_showConfirmpass: !prevState.is_showConfirmpass }))
                  }
                ></i>
              </div>
              <button className="login-button" onClick={(e) => this.handleChangePassword(e)}>Set New Password</button>
              {isReset ? <></> : <>
                <button
                  className="login-button p-0" style={{backgroundColor:"transparent", color:"#1238a9", fontSize:"14px", fontWeight:"500"}}
                  onClick={() => {
                    window.history.back()
                  }}
                >
                 <i class="ri-arrow-left-line" style={{verticalAlign: "bottom"}}></i> Back
                </button>
              </>}
              {/* <a href="#" className="forgot-password" onClick={() => this.navigateLogIn()}>Already a User?</a> */}
            </div>

            {/* <div className="banner-section">
              <div className="banner_inner_section">
                <h3>Inspiring Excellence, Celebrating Global Achievements</h3>
                <img src="img/login_img_boy.png" alt="Celebrating Achievements" className="banner-image" />
              </div>
            </div> */}  
          </div>
        </div>

        <ToastContainer />
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    changePassword_action, verifyOtp_action
  })(ChangePassword)
);
